import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { KudoDetail } from 'features/feed';

type RouteParams = {
  kudosId: string;
};

const PageKudos = () => {
  const { kudosId } = useRequiredParams<RouteParams>();

  return (
    <AppLayout aside>
      <KudoDetail kudosId={kudosId} />
    </AppLayout>
  );
};

export default PageKudos;
